<script>
import formatDate from '@utils/format-date'
import formMixin from './mixins/form'

const DEFAULT_SUBMIT_DATA = {
  sessionUuids: [],
  sessionDates: [],
  sessionRepeatUuids: [],
}

export default {
  components: {
    EventSession: () => import('@components/List/EventSession'),
  },
  mixins: [formMixin],
  props: {
    value: {
      type: Object,
      default: () => {
        return { ...DEFAULT_SUBMIT_DATA }
      },
    },
    cartItem: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeTab: '0',
    }
  },
  methods: {
    formatDate,
    onSubmit() {
      this.$emit('submit')
    },
    onPrev() {
      this.$emit('prev')
    },
    onSelectaAllSession() {
      this.FormMixSubmitData.sessionUuids = this.cartItem.sessions
        .map((item) => {
          return item.sessions.filter((item2) => {
            return item2.canApply && item2.canApply !== 3 && !this.FormMixSubmitData.sessionRepeatUuids.includes(item2.uuid)
          })
        })
        .reduce((prev, curr) => {
          return [...prev, ...curr]
        })
        .map((item) => {
          return item.uuid
        })

      if (this.FormMixSubmitData.sessionUuids[0]) {
        this.onSubmit()
      }
    },
    removeItem(uuid) {
      if (this.FormMixSubmitData.sessionUuids.includes(uuid)) {
        this.FormMixSubmitData.sessionUuids = [
          ...this.FormMixSubmitData.sessionUuids.filter((sessionUuid) => {
            return sessionUuid !== uuid
          }),
        ]
      }
    },
    hasSession(sessionSessionItem) {
      return sessionSessionItem.some((item) => {
        return this.FormMixSubmitData.sessionUuids.includes(item.uuid)
      })
    },
  },
}
</script>
<template>
  <div :class="$style.formApplyStep0">
    <div class="row">
      <div class="col-md-8 order-md-first order-last">
        <el-tabs v-model="activeTab" class="isStyleBase" :class="{ isHiddenHead: cartItem.sessions.length === 1 }" stretch>
          <el-tab-pane v-for="(sessionItem, index) in cartItem.sessions" :key="index" :label="formatDate(sessionItem.date, 'yyyy/MM/dd')" :name="`${index}`">
            <div class="text-base md:text-lg mb-3 color-gray-5"> <i class="fal fa-exclamation-circle"></i> 活動無法重複報名，已報名活動僅供代報名 </div>
            <div class="sectionCourseApply__list">
              <EventSession v-model="FormMixSubmitData.sessionUuids" :event-item="cartItem" :session-item="sessionItem" :session-repeat-uuids="FormMixSubmitData.sessionRepeatUuids" type="apply" />
            </div>
            <BaseButton class="isStylePrimary isOutline2 isFull mb-4 isRadius" :loading="loading" @click="onSelectaAllSession"> 報名所有場次 </BaseButton>
            <BaseButton class="isStylePrimary isFull isRadius" :loading="loading" :disabled="!FormMixSubmitData.sessionUuids[0]" @click="onSubmit"> 下一步 </BaseButton>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="col-md-4 mb-md-0 mb-5">
        <BaseSticky :banner-height="600" :menu-height="113" :space-top="40" :space-bottom="40">
          <div :class="$style.cart">
            <h2 class="cart__title">{{ cartItem.title }}</h2>
            <p v-if="FormMixSubmitData.sessionUuids.length === 0" class="cart__smalText">
              <i class="fal fa-exclamation-circle"></i>
              請選擇場次
            </p>
            <template v-if="FormMixSubmitData.sessionUuids.length !== 0">
              <template v-for="(sessionItem, index) in cartItem.sessions">
                <div v-if="FormMixSubmitData.sessionDates.includes(sessionItem.date)" :key="index" class="cart__group">
                  <h3 class="cart__group__title">
                    {{ formatDate(sessionItem.date, 'yyyy年MM月dd日') }}
                  </h3>
                  <div :class="$style.cartList">
                    <template v-for="(sessionSessionItem, index2) in sessionItem.sessions">
                      <div v-if="FormMixSubmitData.sessionUuids.includes(sessionSessionItem.uuid)" :key="index2" class="cart__item cartList__item">
                        <div class="cart__item__text">
                          {{ sessionSessionItem.title }}
                        </div>
                        <button class="cart__item__btn" @click="removeItem(sessionSessionItem.uuid)">
                          <i class="fal fa-times"></i>
                        </button>
                      </div>
                    </template>
                  </div>
                </div>
              </template>
            </template>
          </div>
          <BaseButton class="isStylePrimary isFull mb-4" :loading="loading" :disabled="!FormMixSubmitData.sessionUuids[0]" @click="onSubmit"> 下一步 </BaseButton>
          <BaseButton class="isStylePrimary isFull isOutline2" :to="{ name: 'brand-event-item' }"> 回到活動介紹頁 </BaseButton>
        </BaseSticky>
      </div>
    </div>
  </div>
</template>
<style lang="scss" module>
// stylelint-disable selector-class-pattern
.formApplyStep0 {
  @include max-md {
    padding-bottom: 3rem;
  }
  :global {
    .formApplyStep0 {
      @include unstyled;
    }
  }
}

.cart {
  padding: 3.125rem 3.125rem;
  margin-bottom: 2rem;
  background-color: #fff;
  box-shadow: 0 0 8px rgba(33, 69, 88, 0.16);
  @include max-md {
    padding: 1.5rem $container-gap;
    // background: transparent;
    box-shadow: none;
  }
  :global {
    .cart {
      &__smalText {
        margin-bottom: 1.5rem;
        font-size: 0.875rem;
        color: $color-gray-5;
      }

      &__title {
        margin-bottom: 2.2rem;
        font-size: 1.25rem;
        line-height: 1.6;
        @include max-md {
          font-size: 1.125rem;
        }
      }

      &__group {
        &:not(:last-child) {
          padding-bottom: 1.5rem;
          border-bottom: $color-gray-3 1px solid;
          margin-bottom: 1.5rem;
        }

        &__title {
          margin-bottom: 0.5rem;
          font-size: 0.875rem;
          color: $color-gray-5;
        }
      }

      &__item {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;

        &__text {
          margin-right: 1.5rem;
          font-size: 1rem;
          color: $color-gray-6;
          line-height: 1.25;
          margin-top: 0.25em;

          @include line-clamp(2, 2.5em);
        }

        &__btn {
          background: none;
          border: 0;
        }
      }
    }
  }
}

.cartList {
  :global {
    .cartList {
      &__item {
        &:not(:last-child) {
          margin-bottom: 1.2rem;
        }
      }
    }
  }
}
</style>
